import { Component, ViewChild, OnInit, ChangeDetectorRef } from '@angular/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { Router } from '@angular/router';
import { HttpService } from '../shared/services/http.service'
import { dashboardResultService } from '../dashboardResultService';
import { SessionHandler } from '../shared/services/session-handler.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Page } from "./datatable/page";
import { MdDialog, MdDialogRef } from '@angular/material';
import { CommonService } from '../shared/services/common.service';
import { dialogComponent } from '../dialog/dialog.component';
import { DaterangepickerConfig } from 'ng2-daterangepicker';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { APPCONFIG } from '../config';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { saveAs } from 'file-saver';
import { FileUploader } from 'ng2-file-upload';
import { FileSelectDirective } from 'ng2-file-upload';
import { addNewAddressComponent } from '../trade/details/addNewAddress.component';
import { FormControl, Validators } from '@angular/forms';
import { LoaderService } from '../loader/loader.service';

@Component({
    selector: 'my-dashboard',
    template: require('./dashboard.component.html'),
    styles: [require('./dashboard.component.scss')],
    providers: [HttpService, SessionHandler]
})
export class DashboardComponent {
    @ViewChild(DatatableComponent) table: DatatableComponent;
    tableRows: any = [];
    page = new Page();
    public rows: any;
    dashboardData = [];
    temp = [];
    showTable: boolean = true;
    userData: any;
    dialogRef;
    reasonList: any;
    fileUrl: any;
    isApprover: boolean = false;
    showAction: boolean = false;
    isFS: boolean = false;
    isAdmin: boolean = false;
    public daterange: any = {};
    filters: any = {};
    customFilters: any;
    arrayKeys: any;
    showFilterList: boolean = false;
    userRole: any;
    isOTD: boolean = false;
    pageName = 'dashboard';
    currentDateRange: any;
    fileURL: any = APPCONFIG.appUrlBase + '/extractFile';
    isOrderDesk: boolean = false;
    isTradeParetner: boolean = false;
    isEndConsumner: boolean = false;
    requestTypeNew: string = 'NEW';
    requestTypeRetry: string = 'RETRY';
    upsDialogRef: MdDialogRef<createUPSDialogComponent>;
    upsShipmentProcess: boolean = false;
    upsBlockedUsers: any;
    reorderable = true;
    allFilterData = [];
    searchfilterInptValue = '';
    returnOrderIdd: any;
    showingMediaErrorMsg: any;
    showingmediaError: any;
    uploadedDocuments: any;
    tableScralled:boolean = false;
    offset:any;
    hideUpdateButton: boolean;


    constructor(private http: HttpService, private serverResultsService: dashboardResultService, private LoaderService: LoaderService,
        private sessionHandler: SessionHandler, public dialog: MdDialog, private daterangepickerOptions: DaterangepickerConfig,
        private commonService: CommonService, private http1: Http) {

        this.page.pageNumber = 0;
        this.page.size = 50;
        if (this.http.checkSession()) {
            this.userData = JSON.parse(this.sessionHandler.getItem('loginData'));
            if (this.userData && Object.keys(this.userData).length > 0 && this.userData.role && this.userData.role.length > 0) {
               
                this.reasonList = JSON.parse(this.sessionHandler.getItem('reasons')); // uncomment this 3 lines if have to use getReasonCode api
                if (this.reasonList == null || this.reasonList.length < 0) {
                    this.getReasonList();
                }
                for (let u in this.userData.role) {
                    if (this.userData.role.includes('APPROVER')) {
                        this.isApprover = true;
                    }
                    if (this.userData.role.includes('OTD_APPROVER')) {
                        this.isOTD = true;
                    }
                    if (this.userData.role.includes('ADMIN')) {
                        this.isAdmin = true;
                    }
                    if (this.userData.role.includes('EMPLOYEE')) {
                        this.isFS = true;
                    }
                    if (this.userData.role.includes('ORDER_DESK_AGENT')) {
                        this.isOrderDesk = true;
                    } if (this.userData.role.includes('TRADE_PARTNER')) {
                        this.isTradeParetner = true;
                    } if (this.userData.role.includes('END_CONSUMER')) {
                        this.isEndConsumner = true;
                    }

                }
                //******Old role logic */
                // for (let u in this.userData.role) {
                //     if (this.userData.role[u] == 'APPROVER') {
                //         this.isApprover = true;
                //     }
                //     if (this.userData.role[u] == 'OTD_APPROVER') {
                //         this.isOTD = true;
                //     }
                //     if (this.userData.role[u] == 'ADMIN') {
                //         this.isAdmin = true;
                //     }
                //     if (this.userData.role[u] == 'EMPLOYEE') {
                //         this.isFS = true;
                //     }
                //     if (this.userData.role[u] == 'ORDER_DESK_AGENT') {
                //         this.isOrderDesk = true;
                //     } if (this.userData.role[u] == 'TRADE_PARTNER') {
                //         this.isTradeParetner = true;
                //     } if (this.userData.role[u] == 'END_CONSUMER') {
                //         this.isEndConsumner = true;
                //     }
                // }
                this.daterangepickerOptions.settings = {
                    locale: { format: 'YYYY-MMM-D' },
                    alwaysShowCalendars: false,
                    startDate: new Date(this.daterange.year, this.daterange.start_mm - 1, this.daterange.date),
                    endDate: new Date(this.daterange.year, this.daterange.end_mm - 1, this.daterange.date),
                    opens: 'left'
                };
                if (this.userData && this.userData.role && this.userData.role.length > 0) {
                    this.userRole = this.userData.role.join();
                }
                var today = new Date();
                this.daterange.date = today.getDate();
                if (today.getMonth() == 0 || today.getMonth() == 1) {
                    this.daterange.start_mm = 12;
                    this.daterange.end_mm = 2;
                    this.daterange.startYear = today.getFullYear() - 1;
                    this.daterange.endYear = today.getFullYear();
                } else {
                    this.daterange.start_mm = today.getMonth() - 1;
                    this.daterange.end_mm = today.getMonth() + 1;
                    this.daterange.startYear = today.getFullYear();
                    this.daterange.endYear = today.getFullYear();
                }
                this.filters['startDate'] = this.daterange.startYear + '-' + this.daterange.start_mm + '-' + this.daterange.date;
                this.filters['endDate'] = this.daterange.endYear + '-' + this.daterange.end_mm + '-' + this.daterange.date;

                //for default date range on dashboard
                var monthNames = ["January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December"];
                this.currentDateRange = monthNames[this.daterange.start_mm - 1] + ' ' + this.daterange.date + ' ' + this.daterange.startYear + ' - ' + monthNames[this.daterange.end_mm - 1] + ' ' + this.daterange.date + ' ' + this.daterange.endYear;

                this.filters['userRoles'] = this.userRole;
                this.filters['email'] = this.userData.email;
                if (this.isFS || this.isAdmin || this.isApprover || this.isOTD) {
                    this.filters['tradePartnerId'] = "";
                } else {
                    this.filters['tradePartnerId'] = this.userData.tradePartnerId;
                }
                if (this.isFS == true) {
                    this.filters['status'] = ['APPR', 'Arrived'];
                }
                this.filters['offSet'] = this.page.pageNumber * this.page.size;




                this.commonService.searchChange.subscribe((value) => {
                    this.searchfilterInptValue = '';
                    this.filterDatatable(this.searchfilterInptValue)
                    this.searchParams(value);
                });
                this.offset = this.page.pageNumber * this.page.size;
                this.getBlockedUsers();
                this.getReasonList();              // uncomment this 3 lines if have to use getReasonCode api
                this.getDashboardData(this.filters);
                this.commonService.setData(null);
            }
        } else {
            this.http.showSessionError();
        }
    }

    ngOnInit() {

    }

    public showLoader(): void {
        this.LoaderService.show();
    }
    public hideLoader(): void {
        this.LoaderService.hide();
    }

    public navigateDocLink(docUrl) {
        this.dialogRef = this.dialog.open(viewDialog);
        this.dialogRef.componentInstance.urlList = docUrl;
        this.http.onEnd();
    }

    public uploadDoc(orderId) {
        this.dialogRef = this.dialog.open(DownloadComponent);
        this.dialogRef.componentInstance.requestNo = orderId;
        this.http.onEnd();
    }

    public getBlockedUsers() {
        this.http.getRequest('returnOrder/v1/getUPSBlockedUsers')
            .subscribe(
                res => { this.saveBlockedUserList(res) },
                err => {
                    console.log(err.status)
                    if(err && err.status!=0){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = 'Failed to load UPS blocked users';
                    }
                    this.http.onEnd();
                });
    }

    public saveBlockedUserList(res) {
        if (res && res.items) {
            this.upsBlockedUsers = res.items;
            //console.log(this.upsBlockedUsers);
            //console.log(this.upsBlockedUsers.length);
        }
        // this.http.onEnd();
    }

    public checkUKAddress(address) {
        if (!address || typeof address !== 'string') {
          return false;
        }
       
        const upper = address.toUpperCase();
        const parts = upper.split('#'); // structured: City#Street#Country#Postal
        const countryToken = parts.length > 2 ? parts[2].trim() : '';
       
        // Known country tokens
        const UK_TOKENS = new Set(['GB', 'UK', 'UNITED KINGDOM', 'U.K.']);
        // const IE_TOKENS = new Set(['IE', 'IRL', 'IRELAND']);
       
        // Prefer checking the country field explicitly
        if (UK_TOKENS.has(countryToken)) {
          return true;
        }
       
        // As a fallback, allow full country names in the whole string (not short codes)
        if (upper.includes('UNITED KINGDOM')) {
          return true;
        }
       
        return false;
      }

    public getReasonList() {
        this.http.getRequest('tradePartnerDetails/v1/getReasonCode')
            .subscribe(
                res => { this.saveReasonList(res) },
                err => {
                    console.log(err)
                    if(err && err.status!=0){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;
                    }
                    this.http.onEnd();
                });
    }


    public saveReasonList(res) {
        if (res && res.items) {
            this.reasonList = res.items;
            this.sessionHandler.saveItem('reasons', JSON.stringify(this.reasonList));
        }
        // this.http.onEnd();
    }

    public searchParams(value) {
        this.customFilters = value['display'];
        this.arrayKeys = Object.keys(this.customFilters);
        // this.currentDateRange = null;
        this.filters = value['filters'];
        this.filters['userRoles'] = this.userRole;
        this.filters['email'] = this.userData.email;
        this.filters['advanceSearch'] = true;

        if (this.userData.tradePartnerId != null) {
            this.filters['tradePartnerId'] = this.userData.tradePartnerId;
        }
        // else {
        //     this.filters['tradePartnerId'] = "";
        // }

        // console.log('trade id :' + this.userData.tradePartnerId);
        /*
        if(this.isFS || this.isAdmin || this.isApprover || this.isOTD){
            this.filters['tradePartnerId'] = "";
        } else {
            this.filters['tradePartnerId'] = this.userData.tradePartnerId;                    
        }
        */

        this.filters['offSet'] = 0;
        this.getDashboardData(this.filters);
        this.showFilterList = true;
        this.dialog.closeAll();
    }

    // /**
    // * Populate the table with new data based on the page number
    // * @param page The page to select
    // */
    setPage(pageInfo, rows, filter) {
        if(!this.tableScralled){

        
        this.page.pageNumber = pageInfo.offset;
        // if (rows.length != 0) {
        this.serverResultsService.getResults(this.page, rows).subscribe(pagedData => {
            this.page = pagedData.page;
            this.tableRows = pagedData.data;
            if (!filter) {
                if (Object.keys(this.tableRows).length == 0 || !this.tableRows[0]['status']) {
                    this.filters['offSet'] = this.page.pageNumber * this.page.size;
                    this.offset = this.page.pageNumber * this.page.size;
                    this.getDashboardData(this.filters);
                }
            }
        });
    }
    this.table.offset = this.page.pageNumber;
    
        // } else {
        //     this.tableRows = [];
        //     // this.page.totalElements = rows.length;
        // }
    }
    handleScroll() {
        this.tableScralled = true;
    
       setTimeout(() => {
          this.tableScralled = false;
       }, 500)
     }
    public getDashboardData(filter) {
        this.http.postRequest(filter, 'returnOrder/v1/listReturnOrders').subscribe(
            res => {
                this.saveDashboardData(res, filter);
            },
            err => {
                if(err && err.status!=0){
                    this.dialogRef = this.dialog.open(dialogComponent);
                    this.dialogRef.componentInstance.msg = 'Failed to retrieve data.';   
                }
                this.http.onEnd();
            }
        );
    }

    // public updateFilter(event, key) {
    //     var options = { year: 'numeric', month: 'short', day: 'numeric' };
    //     const val = event.target.value.toLowerCase();
    //     const temp = this.temp.filter(function (d) {
    //         if (d[key] != null) {
    //             if (key == 'createdOn' || key == 'lastUpdatedOn') {
    //                 var date = new Date(d[key]);
    //                 d[key] = date.toLocaleDateString("en-US", options)
    //             }
    //             return d[key].toLowerCase().indexOf(val) !== -1 || !val;
    //         }
    //     });
    //     this.rows = temp;
    //     this.page.totalElements = this.rows.length;
    //     this.setPage({ offset: 0 }, this.rows, true);
    // }

    public reset() {
        this.showFilterList = false;
        this.filters = {};
        this.filters['userRoles'] = this.userRole;
        this.filters['email'] = this.userData.email;
        if (this.isFS || this.isAdmin || this.isApprover || this.isOTD) {
            this.filters['tradePartnerId'] = "";
        } else {
            this.filters['tradePartnerId'] = this.userData.tradePartnerId;
        }
        this.filters['offSet'] = 0;
        var today = new Date();
        this.daterange.date = today.getDate();
        if (today.getMonth() == 0) {
            this.daterange.start_mm = 12;
            this.daterange.end_mm = 2;
            this.daterange.startYear = today.getFullYear() - 1;
            this.daterange.endYear = today.getFullYear();
        } else {
            this.daterange.start_mm = today.getMonth() - 1;
            this.daterange.end_mm = today.getMonth() + 1;
            this.daterange.startYear = today.getFullYear();
            this.daterange.endYear = today.getFullYear();;
        }
        this.filters['startDate'] = this.daterange.startYear + '-' + this.daterange.start_mm + '-' + this.daterange.date;
        this.filters['endDate'] = this.daterange.endYear + '-' + this.daterange.end_mm + '-' + this.daterange.date;
        if (this.isFS == true) {
            this.filters['status'] = ['APPR', 'Arrived'];
        }
        this.getDashboardData(this.filters);
    }
    public saveDashboardData(res, filter) {
    if (res && res.status == 'Success') {

        this.dashboardData = res;
        this.rows = [];

        var offsetValue = res.offSet ? res.offSet : 0;
        this.rows['offSet'] = offsetValue;

        var items = [];

        if (res && res.items && Array.isArray(res.items)) {
            items = res.items;
        }

        var totalCount = 0;

        if (parseInt(offsetValue) == 0) {
            totalCount = items.length;
            localStorage.setItem('totalCount', totalCount.toString());
        } else {
            var storedCount = localStorage.getItem('totalCount');
            totalCount = storedCount ? parseInt(storedCount) : items.length;
        }

        this.rows['total_count'] = totalCount;

        for (let data in items) {

            var item = items[data];

            /*
             * Handle null, undefined, or empty object row.
             * This avoids showing blank rows and avoids JS errors.
             */
            if (!item || Object.keys(item).length == 0) {
                continue;
            }

            this.rows[data] = {};

            /*
             * Basic IDs
             */
            this.rows[data]['Id'] = item['orderId'] ? item['orderId'] : '';

            if (item['sapOrderId']) {
                this.rows[data]['orderId'] = item['sapOrderId'];
            } else if (item['orderId']) {
                this.rows[data]['orderId'] = 'DRAFT-' + item['orderId'];
            } else {
                this.rows[data]['orderId'] = '';
            }

            /*
             * Common fields
             */
            this.rows[data]['createdBy'] = item['createdBy'] ? item['createdBy'] : '';
            this.rows[data]['tradePartnerId'] = item['tradePartnerId'] ? item['tradePartnerId'] : '';
            this.rows[data]['createdOn'] = item['createdOn'] ? item['createdOn'] : '';
            this.rows[data]['lastUpdatedOn'] = item['lastUpdatedOn'] ? item['lastUpdatedOn'] : '';
            this.rows[data]['returnOrderCategory'] = item['returnOrderCategory'] ? item['returnOrderCategory'] : '';
            this.rows[data]['returnReasonDesc'] = item['returnReasonDesc'] ? item['returnReasonDesc'] : '';
            this.rows[data]['soldTo'] = item['soldTo'] ? item['soldTo'] : '';
            this.rows[data]['approver'] = item['approver'] ? item['approver'] : '';
            this.rows[data]['orderSize'] = item['orderSize'] ? item['orderSize'] : '';
            this.rows[data]['actionDate'] = item['actionDate'] ? item['actionDate'] : '';

            /*
             * Newly added pallet/parcel field
             */
            this.rows[data]['palletOrParcel'] = item['palletOrParcel'] ? item['palletOrParcel'] : '';

            /*
             * Upload document list
             */
            this.rows[data]['uploadedDocList'] = item['uploadedDocList'] ? item['uploadedDocList'] : [];

            /*
             * UPS fields
             */
            this.rows[data]['upsStatus'] = item['upsStatus'] ? item['upsStatus'] : false;
            this.rows[data]['upsConformStatus'] = item['upsConformStatus'] ? item['upsConformStatus'] : false;
            this.rows[data]['coustumerManagedParcel'] = item['coustumerManagedParcel'] ? item['coustumerManagedParcel'] : false;

            /*
             * UK / UPS blocked customer logic
             */
            if (this.upsBlockedUsers != null
                && (
                    this.upsBlockedUsers.includes(item['tradePartnerId'])
                    || this.checkUKAddress(item['address'])
                )
            ) {
                this.rows[data]['ukcustomer'] = true;
            } else {
                this.rows[data]['ukcustomer'] = false;
            }

            /*
             * Return reason mapping
             */
            var reasonFound = false;

            if (this.reasonList && this.reasonList.length > 0) {
                for (let r in this.reasonList) {
                    if (this.reasonList[r].reasonCode == item['returnReason']) {
                        this.rows[data]['returnReason'] = this.reasonList[r].reason;
                        reasonFound = true;
                        break;
                    }
                }
            }

            if (!reasonFound) {
                this.rows[data]['returnReason'] = item['returnReason'] ? item['returnReason'] : '';
            }

            /*
             * Currency and return order value
             */
            var currencySymbol = item['returnOrderCurrency'] ? item['returnOrderCurrency'] : '';
            var symbole = currencySymbol;

            if (currencySymbol == 'EUR') {
                symbole = '€';
            } else if (currencySymbol == 'GBP') {
                symbole = '£';
            } else if (currencySymbol == 'USD') {
                symbole = '$';
            }

            if (item['returnOrderValue']) {
                this.rows[data]['returnOrderValue'] = item['returnOrderValue'] + ' ' + symbole;
            } else {
                this.rows[data]['returnOrderValue'] = '';
            }

            this.rows[data]['returnOrderCurrency'] = item['returnOrderCurrency'] ? item['returnOrderCurrency'] : '';

            /*
             * Status mapping
             */
            if (item['status'] == 'SUBMIT') {
                this.rows[data]['status'] = 'APPROVAL PENDING';
                this.showAction = true;
            } else {
                this.rows[data]['status'] = item['status'] ? item['status'] : '';
            }
        }

        this.showTable = true;
        this.temp = this.rows;

        /*
         * Convert object rows into final array for ngx-datatable.
         */
        let finalRows = [];

        for (let f in this.rows) {
            if (f != 'offSet' && f != 'total_count' && this.rows[f]) {
                finalRows.push(this.rows[f]);
            }

            if (f == 'offSet') {
                finalRows['offSet'] = this.rows['offSet'];
            }

            if (f == 'total_count') {
                finalRows['total_count'] = this.rows['total_count'];
            }
        }

        this.rows = finalRows;
        this.allFilterData = JSON.parse(JSON.stringify(this.rows));

        this.setPage({ offset: this.rows['offSet'] / this.page.size }, finalRows, filter);
        this.http.onEnd();

    } else {
        this.dialogRef = this.dialog.open(dialogComponent);

        if (res && res.errorMessage) {
            this.dialogRef.componentInstance.msg = res.errorMessage;
        } else {
            this.dialogRef.componentInstance.msg = 'Failed to retrieve data.';
        }

        this.http.onEnd();
    }
}

    // public saveDashboardData(res, filter) {
    //     if (res.status == 'Success') {
    //         if (res && Object.keys(res).length > 0) {
    //             this.dashboardData = res;
    //             this.rows = [];
    //             this.rows['offSet'] = res.offSet;
    //             if (this.dashboardData && Object.keys(this.dashboardData).length > 0) {
    //                 if (this.dashboardData['items']) {
    //                     let totalCount = 0;
    //                     if (parseInt(res.offSet) == 0) {
    //                         // localStorage.setItem('totalCount', res.itemCount);  // commented for testing 
    //                         // totalCount = parseInt(res.itemCount);
    //                         let recored_cnt=this.dashboardData['items'].length;
    //                         localStorage.setItem('totalCount', recored_cnt); 
    //                         totalCount=recored_cnt;
    //                         console.log("***********************",recored_cnt);
    //                     } else {
    //                         totalCount = parseInt(localStorage.getItem('totalCount'));
    //                     }
    //                     this.rows['total_count'] = totalCount;
    //                     for (let data in this.dashboardData['items']) {
    //                         this.returnOrderIdd = this.dashboardData['items'][data]['sapOrderId'];
    //                         if (this.isAdmin || this.isOTD || this.isOrderDesk || this.isEndConsumner) {
    //                             if (this.dashboardData['items'][data]['sapOrderId']) {
    //                                 this.rows[data] = {};
    //                                 this.rows[data]['Id'] = this.dashboardData['items'][data]['orderId'];
    //                                 if (this.dashboardData['items'][data]['sapOrderId']) {
    //                                     this.rows[data]['orderId'] = this.dashboardData['items'][data]['sapOrderId'];
    //                                 } else {
    //                                     this.rows[data]['orderId'] = 'DRAFT-' + this.dashboardData['items'][data]['orderId'];
    //                                 }
    //                                 if (this.dashboardData['items'][data]['createdBy']) {
    //                                     this.rows[data]['createdBy'] = this.dashboardData['items'][data]['createdBy'];
    //                                 }

    //                                 this.rows[data]['tradePartnerId'] = this.dashboardData['items'][data]['tradePartnerId'];
    //                                 this.rows[data]['createdOn'] = this.dashboardData['items'][data]['createdOn'];
    //                                 this.rows[data]['returnOrderCategory'] = this.dashboardData['items'][data]['returnOrderCategory'];
    //                                 this.rows[data]['returnReasonDesc'] = this.dashboardData['items'][data]['returnReasonDesc'];

    //                                 var currencySymbol = this.dashboardData['items'][data]['returnOrderCurrency'];
    //                                 var symbole = currencySymbol;
    //                                 if (currencySymbol == 'EUR') {
    //                                     symbole = "€";
    //                                 } else if (currencySymbol == 'GBP') {
    //                                     symbole = "£";
    //                                 } else if (currencySymbol == 'USD') {
    //                                     symbole = "$";
    //                                 }

    //                                 this.rows[data]['returnOrderValue'] = this.dashboardData['items'][data]['returnOrderValue'] + " " + symbole;

    //                                 this.rows[data]['lastUpdatedOn'] = this.dashboardData['items'][data]['lastUpdatedOn'];
    //                                 this.rows[data]['soldTo'] = this.dashboardData['items'][data]['soldTo'];
    //                                 this.rows[data]['approver'] = this.dashboardData['items'][data]['approver'];
    //                                 this.rows[data]['orderSize'] = this.dashboardData['items'][data]['orderSize'];
    //                                 this.rows[data]['actionDate'] = this.dashboardData['items'][data]['actionDate'];




    //                                 this.rows[data]['uploadedDocList'] = this.dashboardData['items'][data]['uploadedDocList'];


    //                                 this.rows[data]['upsStatus'] = this.dashboardData['items'][data]['upsStatus'];
    //                                 this.rows[data]['coustumerManagedParcel'] = this.dashboardData['items'][data]['coustumerManagedParcel'];
    //                                 this.rows[data]['upsConformStatus'] = this.dashboardData['items'][data]['upsConformStatus'];

    //                                 if (this.upsBlockedUsers != null
    //                                     // && (!this.dashboardData['items'][data]['ukcustomerAndisUPSBlockedCustomer'])
    //                                     && (this.upsBlockedUsers.includes(this.dashboardData['items'][data]['tradePartnerId'])
    //                                         || this.checkUKAddress(this.dashboardData['items'][data]['address']))
    //                                 ) {
    //                                     this.rows[data]['ukcustomer'] = true;
    //                                     //console.log('ups blocked');
    //                                 } else {
    //                                     this.rows[data]['ukcustomer'] = false;
    //                                 }


    //                                 //this.rows[data]['ukcustomer'] = this.dashboardData['items'][data]['ukcustomerAndisUPSBlockedCustomer'];


    //                                 if (this.reasonList && this.reasonList.length > 0) {
    //                                     for (let r in this.reasonList) {
    //                                         if (this.reasonList[r].reasonCode == this.dashboardData['items'][data]['returnReason']) {
    //                                             this.rows[data]['returnReason'] = this.reasonList[r].reason;
    //                                         }
    //                                     }
    //                                 } else {
    //                                     this.rows[data]['returnReason'] = this.dashboardData['items'][data]['returnReason'];
    //                                 }
                                        

    //                                 if (this.dashboardData['items'][data]['status'] == 'SUBMIT') {
    //                                     this.rows[data]['status'] = 'APPROVAL PENDING';
    //                                     this.showAction = true;
    //                                 } else {
    //                                     this.rows[data]['status'] = this.dashboardData['items'][data]['status'];
    //                                 }
    //                             } else {
    //                                 this.rows['total_count']--;
    //                             }
    //                         } else {
    //                             this.rows[data] = {};
    //                             this.rows[data]['Id'] = this.dashboardData['items'][data]['orderId'];
    //                             if (this.dashboardData['items'][data]['sapOrderId']) {
    //                                 this.rows[data]['orderId'] = this.dashboardData['items'][data]['sapOrderId'];
    //                             } else {
    //                                 this.rows[data]['orderId'] = 'DRAFT-' + this.dashboardData['items'][data]['orderId'];
    //                             }
    //                             this.rows[data]['tradePartnerId'] = this.dashboardData['items'][data]['tradePartnerId'];
    //                             this.rows[data]['createdOn'] = this.dashboardData['items'][data]['createdOn'];
    //                             this.rows[data]['lastUpdatedOn'] = this.dashboardData['items'][data]['lastUpdatedOn'];
    //                             this.rows[data]['upsStatus'] = this.dashboardData['items'][data]['upsStatus'];
    //                             this.rows[data]['coustumerManagedParcel'] = this.dashboardData['items'][data]['coustumerManagedParcel'];
    //                             this.rows[data]['upsConformStatus'] = this.dashboardData['items'][data]['upsConformStatus'];

    //                             if (this.upsBlockedUsers != null
    //                                 // && (!this.dashboardData['items'][data]['ukcustomerAndisUPSBlockedCustomer'])
    //                                 && (this.upsBlockedUsers.includes(this.dashboardData['items'][data]['tradePartnerId'])
    //                                     || this.checkUKAddress(this.dashboardData['items'][data]['address']))
    //                             ) {
    //                                 this.rows[data]['ukcustomer'] = true;
    //                                 //console.log('ups blocked');
    //                             } else {
    //                                 this.rows[data]['ukcustomer'] = false;
    //                             }
    //                             // this.rows[data]['ukcustomer'] = this.dashboardData['items'][data]['ukcustomerAndisUPSBlockedCustomer'];

    //                             this.rows[data]['returnOrderCategory'] = this.dashboardData['items'][data]['returnOrderCategory'];
    //                             this.rows[data]['returnReasonDesc'] = this.dashboardData['items'][data]['returnReasonDesc'];
    //                             this.rows[data]['returnOrderValue'] = this.dashboardData['items'][data]['returnOrderValue'];
    //                             this.rows[data]['returnOrderCurrency'] = this.dashboardData['items'][data]['returnOrderCurrency'];

    //                             this.rows[data]['soldTo'] = this.dashboardData['items'][data]['soldTo'];
    //                             this.rows[data]['approver'] = this.dashboardData['items'][data]['approver'];
    //                             this.rows[data]['orderSize'] = this.dashboardData['items'][data]['orderSize'];
    //                             this.rows[data]['actionDate'] = this.dashboardData['items'][data]['actionDate'];


    //                             this.rows[data]['uploadedDocList'] = this.dashboardData['items'][data]['uploadedDocList'];


    //                             if (this.reasonList && this.reasonList.length > 0) {
    //                                 for (let r in this.reasonList) {
    //                                     if (this.reasonList[r].reasonCode == this.dashboardData['items'][data]['returnReason']) {
    //                                         this.rows[data]['returnReason'] = this.reasonList[r].reason;
    //                                     }
    //                                 }
    //                             } else {
    //                                 this.rows[data]['returnReason'] = this.dashboardData['items'][data]['returnReason'];
    //                             }
    //                             if (this.dashboardData['items'][data]['status'] == 'SUBMIT') {
    //                                 this.rows[data]['status'] = 'APPROVAL PENDING';
    //                                 this.showAction = true;
    //                             } else {
    //                                 this.rows[data]['status'] = this.dashboardData['items'][data]['status'];
    //                             }
    //                         }
    //                         this.rows[data] = this.rows[data] || {};
    //                         this.rows[data]['palletOrParcel'] = (this.dashboardData['items'][data] && this.dashboardData['items'][data]['palletOrParcel'])?this.dashboardData['items'][data]['palletOrParcel']:'';
    //                     }
    //                     this.showTable = true;
    //                     this.temp = this.rows;
    //                 }
    //             }
    //             let finalRows = [];
    //             for (let f in this.rows) {
    //                 if (f != 'offSet' && f != 'total_count' && this.rows[f]) {
    //                     finalRows.push(this.rows[f]);
    //                 }
    //                 if (f == 'offSet') {
    //                     finalRows['offSet'] = this.rows['offSet'];
    //                 }
    //                 if (f == 'total_count') {
    //                     finalRows['total_count'] = this.rows['total_count'];
    //                 }
    //             }
    //             this.rows = finalRows;
    //             this.setPage({ offset: this.rows['offSet'] / this.page.size }, finalRows, filter);
    //             this.http.onEnd();
    //         }
    //     } else {
    //         this.dialogRef = this.dialog.open(dialogComponent);
    //         this.dialogRef.componentInstance.msg = res.errorMessage;
    //         this.http.onEnd();
    //     }
    //     this.allFilterData = JSON.parse(JSON.stringify(this.rows));

    // }

    viewDocs(orderIdSAP) {
        this.uploadedDocuments = {
            transactionId: orderIdSAP
        }
        this.imageShow(this.uploadedDocuments);     //call ServiceDc Api
    }

    imageShow(data) {
        this.http.downloadPostRequest('document/downloadDocument', data).subscribe(
            res => {
                this.navigateDocLink(res['data']);
                this.http.onEnd();
            },
            err => {
                this.http.onEnd();

                this.showingMediaErrorMsg = "error in fetch image data";
                this.showingmediaError = true;
            }
        );
    }




    public printLabel(id) {
        let data = {};
        data['orderId'] = id;
        this.http.postRequest(data, 'returnOrder/v1/printLabelPdf').subscribe(
            res => {
                this.savePrintResponse(id, res);
            },
            err => {
                if(err && err.status!=0){
                    this.dialogRef = this.dialog.open(dialogComponent);
                    this.dialogRef.componentInstance.msg = 'Failed to print label';
                        
                }
                this.http.onEnd();
            }
        );
    }


    public savePrintResponse(id, res) {
        if (res.responseStatus == 'Success') {
            window.open(res.fileUrl, "_blank");
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Unable to print label.';
        }
        this.http.onEnd();
    }


    public updateStatus(id, status) {
        let txtStatus;
        if (status == 'approved') {
            txtStatus = 'APPROVE';
        } else if (status == 'rejected') {
            txtStatus = 'REJECT';
        }
        this.dialogRef = this.dialog.open(dialogComponent);
        this.dialogRef.componentInstance.msg = 'Are you sure you want to ' + txtStatus + ' this request?';
        this.dialogRef.componentInstance.isConfirm = true;
        this.dialogRef.afterClosed().subscribe(result => {
            if (result) {
                let data = {};
                data['email'] = this.userData.email;
                data['userId']=this.userData.userId;
                data['orderId'] = id;
                if (status == 'approved') {
                    data['status'] = 'APPR';
                } else if (status == 'rejected') {
                    data['status'] = 'REJE';
                }
                let today = new Date();
                let dd = ('0' + today.getDate()).slice(-2);
                let mm = ('0' + (today.getMonth() + 1)).slice(-2);
                let yyyy = today.getFullYear();
                data['approvalDate'] = yyyy + '' + mm + '' + dd;

                this.http.postRequest(data, 'returnOrder/v1/updateReturnOrderStatus').subscribe(
                    res => {
                        this.saveResponse(id, status, res);
                    },
                    err => {
                        if(err && err.status!=0){
                            this.dialogRef = this.dialog.open(dialogComponent);
                            this.dialogRef.componentInstance.msg = err;
                        
                        }
                        this.http.onEnd();
                    }
                );
            }
            this.dialogRef = null;
        });
    }

    public saveResponse(id, status, res) {
        if (res.status == 'Success') {
            if (status == 'approved') {
                status = 'APPROVED';
            } else if (status == 'rejected') {
                status = 'REJECTED';
            }
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Request successfully ' + status;
            for (let r in this.rows) {
                if (this.rows[r].orderId == id) {
                    this.rows[r].status = status;
                    this.rows[r].upsShipmentProcess = true;
                }
            }
            this.http.onEnd();
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            if (res.errorMessage) {
                this.dialogRef.componentInstance.msg = res.errorMessage;
            } else {
                this.dialogRef.componentInstance.msg = 'Failed to process request. Please contact administrator.';
            }
            this.http.onEnd();
        }
    }

    public advanceSearch() {
        this.dialogRef = this.dialog.open(searchDialog);
        this.dialogRef.componentInstance.reason = this.reasonList;
        this.dialogRef.componentInstance.isFS = this.isFS;
        this.dialogRef.componentInstance.isApprover = this.isApprover;
        this.dialogRef.componentInstance.isAdmin = this.isAdmin;
        this.dialogRef.componentInstance.isOTD = this.isOTD;
        this.dialogRef.componentInstance.isEndConsumner = this.isEndConsumner;
        this.dialogRef.componentInstance.isOrderDesk = this.isOrderDesk;

    }

    public extractFile() {
        this.showLoader();
        this.getFile(this.fileURL).subscribe(fileData => {
            this.hideLoader();
            let fileName = "extract_file_" + Date.now() + ".xlsx";
            var file = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;' });
            saveAs(file, fileName);
        });
        //this.http.onEnd();
        
    }

    public getFile(path: string): Observable<any> {
        // let temp_dashboardData = JSON.parse(JSON.stringify(this.dashboardData));
        let temp_dashboardData = [];
        console.log(this.dashboardData)
        console.log(this.rows)


        // this.dashboardData['items'] = temp_dashboardData['items'];
        // this.dashboardData['itemCount']  = temp_dashboardData['items'].length;

        let headers = new Headers({
            'Content-Type': 'application/json',
            apiKey: 'AIzaSyDYlzt8e-7tSUzzDS802X_4RgQMmx0N79Y',
            'access-token': this.sessionHandler.getItem('token')

        });
        let options = new RequestOptions({ headers: headers, responseType: ResponseContentType.Blob });

        // let options = new RequestOptions({ responseType: ResponseContentType.Blob });
        return this.http1
            .post(path, JSON.stringify(this.dashboardData), options)
            .map((response: Response) => <Blob>response.blob());
    }

    updateShipping(id, request, tradeId) {
        this.dialogRef = this.dialog.open(dialogComponent);
        this.dialogRef.componentInstance.msg = "Are you sure want to request to UPS label ?";
        this.dialogRef.componentInstance.isConfirm = true;
        this.dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.openUPSRequestModel(id, request, tradeId);
            }
        });

    }

    openUPSRequestModel(id, request, tradeId) {
        this.http.getRequest('returnOrder/v1/getUPSDataDetail?sapOrderId=' + id)
            .subscribe(
                res => {
                    let data = res;
                    this.http.onEnd();
                    console.log(res);
                    if (data['status'] == 'Success') {
                        this.upsDialogRef = this.dialog.open(createUPSDialogComponent), { skipHide: true };
                        this.upsDialogRef.componentInstance.id = id;
                        this.upsDialogRef.componentInstance.tradeId = tradeId;
                        this.upsDialogRef.componentInstance.isConfirm = true;
                        this.upsDialogRef.componentInstance.request = request;
                        this.upsDialogRef.componentInstance.data = data['upsLabelRequest'];
                        this.upsDialogRef.afterClosed().subscribe(result => {
                            console.log("Result", result);
                            if (result) {
                                if (result.check) {
                                    console.log("Result is TRUE!", result.requestType);
                                    this.upsRequest(id, result.requestType);
                                }
                            }
                        });
                    } else {
                        this.dialogRef = this.dialog.open(dialogComponent);
                        if (data['errorMessage']) {
                            this.dialogRef.componentInstance.msg = data['errorMessage'];
                        } else {
                            this.dialogRef.componentInstance.msg = 'Failed to process request. Please contact administrator.';
                        }
                    }
                    this.http.onEnd();
                },
                err => {
                    if(err && err.status!=0){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;
                        
                    }
                    this.http.onEnd();
                });
    }
    getShipping(id, tradeId, upsStatus) {

        // this.http.getRequest('returnOrder/v1/getUPSDataBySOCOrderId?sapOrderId=' + id)
        //     .subscribe(
        //         res => {
        //             let data = res;
        //             this.http.onEnd();
        //             console.log(res);
        //             if (data['status'] == 'Success') {
        //                 this.dialogRef = this.dialog.open(UPSUpdateComponent);
        //                 this.dialogRef.componentInstance.data = data['upsLabelRequest'];
        //                 this.dialogRef.afterClosed().subscribe(result => {
        //                     if (result) {
        //                         this.openUPSRequestModel(id, this.requestTypeRetry, tradeId)
        //                     }
        //                 });

        //             } else {
        //                 this.dialogRef = this.dialog.open(dialogComponent);
        //                 if (data['errorMessage']) {
        //                     this.dialogRef.componentInstance.msg = data['errorMessage'];
        //                 } else {
        //                     this.dialogRef.componentInstance.msg = 'Failed to process request. Please contact administrator.';
        //                 }
        //             }
        //             this.http.onEnd();
        //         },
        //         err => {
        //             this.dialogRef = this.dialog.open(dialogComponent);
        //             this.dialogRef.componentInstance.msg = err;
        //             this.http.onEnd();
        //         });
        var currentUpsLabel = [];
        var oldUpsLabel = [];
        this.http.getRequest('returnOrder/v1/getUPSDataBySOCOrderId?sapOrderId=' + id)
            .subscribe(
                res => {
                    let data = res;
                    this.http.onEnd();
                    console.log(res);
                    if (data['status'] == 'Success') {
                        var upsLabels = data['upsLabelRequest'];
                        for (var i = 0; i < upsLabels.length; i++) {
                            if (upsLabels[i].delete) {
                                oldUpsLabel.push(upsLabels[i]);

                            } else {
                                currentUpsLabel.push(upsLabels[i]);
                            }

                        }
                        this.dialogRef = this.dialog.open(UPSUpdateComponent);
                        this.dialogRef.componentInstance.upsStatus = upsStatus;
                        this.dialogRef.componentInstance.data = data['upsLabelRequest'];
                        this.dialogRef.componentInstance.currentData = currentUpsLabel;
                        this.dialogRef.componentInstance.oldData = oldUpsLabel;
                        this.dialogRef.afterClosed().subscribe(result => {
                            if (result) {
                                this.openUPSRequestModel(id, this.requestTypeRetry, tradeId)
                            }
                        });

                    } else {
                        this.dialogRef = this.dialog.open(dialogComponent);
                        if (data['errorMessage']) {
                            this.dialogRef.componentInstance.msg = data['errorMessage'];
                        } else {
                            this.dialogRef.componentInstance.msg = 'Failed to process request. Please contact administrator.';
                        }
                    }
                    this.http.onEnd();
                },
                err => {
                    if(err && err.status!=0){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;
                        
                    }
                    this.http.onEnd();
                });

    }
    upsRequest(id, requestType) {
        let email = this.userData.email;
        console.log("test  " + id + "---" + requestType);
        this.http.getRequest('returnOrder/v1/upsShipmentBySapId?sapOrderId=' + id + "&upsRequestType=" + requestType + "&email=" + email)
            .subscribe(
                res => {
                    let data = res;
                    this.http.onEnd();
                    console.log(res);
                    // this.dialogRef = this.dialog.open(UPSUpdateComponent);
                    // this.dialogRef.componentInstance.data = data['shipmentResponse'];
                    if (data['responseCode'].includes('1')) {
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = "UPS Label request successfully for order Id :-" + id;
                        this.dialogRef.afterClosed().subscribe(result => {
                            if (result) {
                                console.log("Result is TRUE!");
                                //   this.upsRequest(id);
                                window.location.reload();
                            }
                        });

                    } else {
                        this.dialogRef = this.dialog.open(dialogComponent);
                        if (data['errorMessage']) {
                            this.dialogRef.componentInstance.msg = data['errorMessage'];
                        } else {
                            this.dialogRef.componentInstance.msg = 'Failed to process request. Please contact administrator.';
                        }
                    }
                    this.http.onEnd();
                },
                err => {
                    if(err && err.status!=0){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;
                        
                    }
                    this.http.onEnd();
                });

    }
    resendeLabel(id) {
        this.http.getRequest('returnOrder/v1/resendLabelReturnOrder?orderId=' + id)
            .subscribe(
                res => {
                    let data = res;
                    this.http.onEnd();
                    console.log(res);
                    if (data['status'] == 'Success') {
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = "UPS Label re-send successfully for order Id :-" + id;
                    } else {
                        this.dialogRef = this.dialog.open(dialogComponent);
                        if (data['errorMessage']) {
                            this.dialogRef.componentInstance.msg = data['errorMessage'];
                        } else {
                            this.dialogRef.componentInstance.msg = 'Failed to process request. Please contact administrator.';
                        }
                    }
                    this.http.onEnd();
                },
                err => {
                    if(err && err.status!=0){
                        
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;
                    }
                    this.http.onEnd();
                });
    }

    filterDatatable(event) {
        console.log(event)
        this.searchfilterInptValue = event;
        let data = this.commonService.filterDatatable(event, this.allFilterData);
        this.rows = data.data;


        // this.table.offset = data.table_offset;
        // this.page.totalElements = this.rows.length;
        // this.setPage({ offset: 0 }, this.rows, true);
        // console.log(this.rows)
        // let temp_dashboardData=[];
        // this.dashboardData['items'].forEach((element,index) => {
        //     this.rows.forEach((row,j) => {
        //         if(element.orderId==row.Id){
        //             temp_dashboardData.push(element)
        //         }
        //     });
        // });
        // this.dashboardData['items'] = temp_dashboardData;
        // this.dashboardData['itemCount']  = temp_dashboardData.length;

        this.dashboardData['items'] = this.rows;
        this.dashboardData['itemCount'] = this.rows.length;

    }
}

// search open dialog
@Component({
    template: require('./search.component.html'),
    providers: [HttpService, SessionHandler]
})
export class searchDialog implements OnInit {
    searchForm: FormGroup;
    searchParams: any = {};
    isFS: boolean = false;
    isApprover: boolean = false;
    isAdmin: boolean = false;
    isOTD: boolean = false;
    isEndConsumner: boolean = false;
    isOrderDesk: boolean = false;
    res: any;
    usersData = [];
    formData: any;
    statusList: any;
    shipment: any;
    reason: any;
    selectedStatus: any;
    daterange: any = {};
    public mapping = [
        {
            'status': 'Status',
            'returnOrderId': 'Return Order ID',
            'shipmentType': 'Shipment Type',
            'reasonCode': 'Reason Code',
            'createdBy': 'Created By',
            'tradePartnerId': "Customer number",
            'serialNumber': 'Serial number',
            'returnReference': 'Return Reference'

        }
    ];
    constructor(private formBuilder: FormBuilder, private daterangepickerOptions: DaterangepickerConfig, public dialog: MdDialog, private commonService: CommonService) {
        this.searchParams.display = {};
        this.searchParams.filters = {};
        this.searchParams.filters.status = [];
        this.searchParams.display.Status = [];
        this.shipment = ["Parcel", "Pallet"];
        var monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];
        var today = new Date();
        this.daterange.date = today.getDate();
        if (today.getMonth() == 0 || today.getMonth() == 1) {
            this.daterange.start_mm = 12;
            this.daterange.end_mm = 2;
            this.daterange.startYear = today.getFullYear() - 1;
            this.daterange.endYear = today.getFullYear();
        } else {
            this.daterange.start_mm = today.getMonth() - 1;
            this.daterange.end_mm = today.getMonth() + 1;
            this.daterange.startYear = today.getFullYear();
            this.daterange.endYear = today.getFullYear();
        }
        this.searchParams['display']['Date Interval'] = monthNames[this.daterange.start_mm - 1] + ' ' + this.daterange.date + ' ' + this.daterange.startYear + ' - ' + monthNames[this.daterange.end_mm - 1] + ' ' + this.daterange.date + ' ' + this.daterange.endYear;
        this.searchParams['filters']['startDate'] = this.daterange.startYear + '-' + this.daterange.start_mm + '-' + this.daterange.date;
        this.searchParams['filters']['endDate'] = this.daterange.endYear + '-' + this.daterange.end_mm + '-' + this.daterange.date;

        this.daterangepickerOptions.settings = {
            locale: { format: 'YYYY-MMM-D' },
            alwaysShowCalendars: false,
            startDate: new Date(this.daterange.startYear, this.daterange.start_mm - 1, this.daterange.date),
            endDate: new Date(this.daterange.endYear, this.daterange.end_mm - 1, this.daterange.date),
            buttonClasses: "btn",
            opens: 'center'
        };
    }
    ngOnInit(): void {
        if (this.isFS) {
            this.statusList = [{ text: "Approved", id: "APPR" }, { text: "Arrived", id: "Arrived" },{ text: "Incomplete", id: "Incomplete" }];
            this.selectedStatus = 'APPR';
        } else if (this.isApprover || this.isAdmin || this.isOTD) {
            this.statusList = [{ text: "Approval Pending", id: "Submit" }, { text: "Approved", id: "APPR" }, { text: "Rejected", id: "REJE" }, { text: "Arrived", id: "Arrived" },{ text: "Incomplete", id: "Incomplete" }];
        } else {
            this.statusList = [{ text: "Approval Pending", id: "Submit" }, { text: "Approved", id: "APPR" }, { text: "Rejected", id: "REJE" }, { text: "Draft", id: "Draft" }, { text: "Arrived", id: "Arrived" },{ text: "Incomplete", id: "Incomplete" }];
        }
        this.buildForm();
    }

    public buildForm() {
        this.searchForm = this.formBuilder.group({
            status: this.formBuilder.control(null, []),
            returnOrderId: this.formBuilder.control(null, []),
            shipmentType: this.formBuilder.control(null, []),
            reasonCode: this.formBuilder.control(null, []),
            createdBy: this.formBuilder.control(null, []),
            tradePartnerId: this.formBuilder.control(null, []),
            serialNumber: this.formBuilder.control(null, []),
            returnReference: this.formBuilder.control(null, [])
        });
    }

    

    public selectedDate(value: any) {
        this.searchParams['filters']['startDate'] = value.start.format('YYYY-MM-DD');
        this.searchParams['filters']['endDate'] = value.end.format('YYYY-MM-DD');
        this.searchParams['display']['Date Interval'] = value.start.format('MMMM D YYYY') + ' - ' + value.end.format('MMMM D YYYY');
    }

    public keyMapping(key) {

        for (let index of this.mapping) {
            if (index[key]) {

                return index[key];

            }
        }
    }



    public selected(value: any) {

        this.searchParams['filters']['status'].push(value.id);
        this.searchParams['display']['Status'].push(value.text);
    }

    public removed(value: any) {
        var index = this.searchParams['filters']['status'].indexOf(value.id);
        if (index >= 0) {
            this.searchParams['filters']['status'].splice(index, 1);
        }
        var index2 = this.searchParams['display']['Status'].indexOf(value.text);
        if (index2 >= 0) {
            this.searchParams['display']['Status'].splice(index2, 1);
        }
    }



    public search() {
        this.formData = this.searchForm.getRawValue();
        console.log(this.formData)
        for (let data in this.formData) {
            if (this.formData[data] && this.formData[data] != "") {
                this.searchParams['filters'][data] = this.formData[data];
                let key = this.keyMapping(data);

                // if(data == 'status'){
                //     this.searchParams['filters'][data] = [];
                //     if(this.formData[data] == 'Submit'){
                //         this.searchParams['display'][key] = 'Approval Pending';
                //     }
                //     if(this.formData[data] == 'APPR'){
                //         this.searchParams['display'][key] = 'Approved';
                //     }
                //     if(this.formData[data] == 'REJE'){
                //         this.searchParams['display'][key] = 'Rejected';
                //     }
                //     if(this.formData[data] != 'REJE' && this.formData[data] != 'APPR' && this.formData[data] != 'Submit'){
                //         this.searchParams['display'][key] = this.formData[data];
                //     }
                //     this.searchParams['filters'][data].push(this.formData[data]);
                // }

                if (data == 'reasonCode') {
                    if (this.reason && this.reason.length > 0) {
                        for (let r in this.reason) {
                            if (this.reason[r].reasonCode == this.formData[data]) {
                                this.searchParams['display'][key] = this.reason[r].reason;
                            }
                        }
                    }
                }
                if (data != 'status' && data != 'reasonCode') {
                    this.searchParams['display'][key] = this.formData[data];
                }
            }
        }
        this.commonService.changeSearchData(this.searchParams);
    }

    public closeDialog() {
        this.dialog.closeAll();
    }
}

// view open dialog

@Component({
    template: require('./view.component.html'),
    providers: [HttpService, SessionHandler]
})
export class viewDialog implements OnInit {
    //url: string = "https://storage.googleapis.com/kitchenaid-web-return-dev.appspot.com/ReturnUploadedDocs/challan_receipt.pdf";
    urlSafe: SafeResourceUrl;
    urlList: any = [];
    safeUrlList: any = [];
    constructor(private formBuilder: FormBuilder, public dialog: MdDialog, private commonService: CommonService, public sanitizer: DomSanitizer) {

    }
    ngOnInit(): void {
        //this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    }

    public fullView(docUrl) {
        window.open(docUrl, "_blank");
    }

    public closeDialog() {
        this.dialog.closeAll();
    }
}

// file download dialog
import { ErrorHandler } from '../shared/services/error-handler.service'
import * as $ from 'jquery';

@Component({
    template: require('./download.component.html'),
    providers: [HttpService, ErrorHandler, SessionHandler]
})
export class DownloadComponent implements OnInit {
    urlList: any = [];
    uploader;
    fileUploadResponse: any;
    isFileUploaded: boolean = false;
    isFileUploadError: boolean = false;
    URL: any = APPCONFIG.appUrlBase + '/uploadFiles';
    fileUrl: any = [];
    requestNo: string;
    fileProcessStart: boolean = false;
    token;
    constructor(private formBuilder: FormBuilder, public dialog: MdDialog, private commonService: CommonService,
        private http: HttpService, private http1: Http, private sessionHandler: SessionHandler, private router: Router
    ) {
        this.token = this.sessionHandler.getItem('token');
        if (this.http.checkSession()) {
            this.uploader = new FileUploader({ url: this.URL, disableMultipart: true });

        } else {
            this.http.showSessionError();
        }
    }
    ngOnInit(): void {
        this.uploader = new FileUploader({ url: this.URL, disableMultipart: true });
    }

    public buildForm() {

    }


    public closeDialog() {
        this.dialog.closeAll();
        if (this.isFileUploaded) {
            window.location.reload();
        }
    }

    public fileupload() {
        this.fileProcessStart = true;
        let formData = new FormData();
        for (let i in this.uploader.queue) {
            this.http.showLoader();
            this.isFileUploaded = true;
            formData.append('file', this.uploader.queue[i]._file);
            let headers = new Headers({
                'apiKey': 'AIzaSyDYlzt8e-7tSUzzDS802X_4RgQMmx0N79Y', 'requestNo': this.requestNo, 'access-token': this.sessionHandler.getItem('token')
            });
            this.sessionHandler.saveItem("timestamp", Math.round(new Date().getTime() / 1000.0));
            this.http1
                .post(this.URL, formData, { headers: headers })
                .toPromise()
                .then(res => this.setUploadData(res.json()))
                .catch(error => this.handleError(error))
        }
    }

    public handleError(e) {
        //this.showError(e, false);
        console.log('error found -- file upload....' + e);
        this.fileUploadResponse = e;
        this.fileProcessStart = false;
        this.isFileUploadError = true;
        this.http.onEnd();
    }

    public setUploadData(res) {
        this.uploader = new FileUploader({ url: this.URL, disableMultipart: true });
        if (res.responseCode == 200) {
            this.isFileUploadError = false;
            //this.fileUrl.push(res.fileUrl);
            this.fileUploadResponse = res.message;
        } else if (res.responseCode == 400) {
            this.isFileUploadError = true;
            this.fileUploadResponse = res.message;
        }
        this.fileProcessStart = false;
        this.http.onEnd();
    }

}




// ups label upload dialog

@Component({
    template: require('./upsUpdate.component.html'),
    providers: [HttpService, ErrorHandler, SessionHandler]
})
export class UPSUpdateComponent implements OnInit {
    public requestNo: string;
    public data: any;
    public msg: any;

    public currentData: any;
    public oldData: any;
    public upsStatus: any;
    constructor(private formBuilder: FormBuilder, public dialog: MdDialog, private commonService: CommonService,
        private http: HttpService, private http1: Http, private sessionHandler: SessionHandler, private router: Router, public dialogRef: MdDialogRef<dialogComponent>
    ) {
        if (this.http.checkSession()) {

        } else {
            this.http.showSessionError();
        }
    }
    ngOnInit(): void {
        console.log(this.currentData)
        console.log(this.oldData)
        console.log(this.data)
    }



    public closeDialog() {
        this.dialog.closeAll();
    }


}


@Component({
    template: require('./createUPSDialog.component.html'),
    providers: [HttpService, SessionHandler]
})
export class createUPSDialogComponent implements OnInit {
    public msg: any;
    public id: any;
    public data: any;
    public tradeId: any;
    public isConfirm: boolean = false;
    public RequestType: any = [];
    public selectedRequestType: any;
    public request: string = '';
    addressList: any;
    isIcb: boolean = false;
    newAddress: any;
    userData: any;
    isTradeParetner: boolean = false;
    enableButtons: boolean = false;
    isEndConsumner: boolean = false;
    dialogRef;
    constructor(public dialog: MdDialog, public dialogRef1: MdDialogRef<addNewAddressComponent>, private dialogRefSelf: MdDialogRef<createUPSDialogComponent>, private http: HttpService, private sessionHandler: SessionHandler, private commonService: CommonService, private changeDetectorRef: ChangeDetectorRef) {
        if (this.http.checkSession()) {
            this.userData = JSON.parse(this.sessionHandler.getItem('loginData'));
            if (this.userData) {
                if (this.userData.role && this.userData.role.length > 0) {
                    for (let u in this.userData.role) {
                        if (this.userData.role[u] == 'TRADE_PARTNER') {
                            this.isTradeParetner = true;
                        }
                        if (this.userData.role[u] == 'END_CONSUMER') {
                            this.isEndConsumner = true;
                        }
                    }
                }

            }
            this.commonService.addressChange.subscribe(() => {
                this.getAddress();
            });
        } else {
            this.http.showSessionError();
        }
    }

    ngOnInit(): void {
        // if(this.request.toLocaleLowerCase().includes('retry')){
        //     this.RequestType = [{key:"004",value:"Pickup Attempt (RS1)"},{key:"003",value:"Pickup Attempts (RS3)"} ];
        //     this.selectedRequestType = "003";
        // }else{
        this.RequestType = [{ key: "001", value: "UPS Standard" }, { key: "004", value: "Pickup Attempt (RS1)" }, { key: "003", value: "Pickup Attempts (RS3)" }];
        this.selectedRequestType = "001";
        //        }
    }
    ngAfterContentInit() {
        if (this.isTradeParetner || this.isEndConsumner) {
            var that = this;
            setTimeout(function () {
                that.getAddress();
                console.log("test")
            }, 1000);
        }
    }
    public closeDialog() {
        this.dialog.closeAll();
    }
    confromDialog(confirmation: boolean) {
        var data = { "check": confirmation, "requestType": this.selectedRequestType };
        console.log(data);
        this.dialogRefSelf.close(data);
    }
    getAddress() {
        let data = {};
        data['tradePartnerId'] = this.tradeId;
        data['salesOrgId'] = APPCONFIG.salesOrgId;
        data['isICBUser'] = this.isIcb;
        this.http.postRequest(data, 'tradePartnerDetails/v1/invoiceBillingAddress')
            .subscribe(
                res => {
                    this.saveAddressList(res);
                },
                err => {
                    if(err && err.status!=0){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;
                        
                    }
                    this.http.onEnd();
                });
    }

    public saveAddressList(res) {
        if (res.billingAddress) {
            var billingData = res.billingAddress;
        }
        if (res.shippingAddressList.length > 0) {
            this.addressList = res.shippingAddressList;
            //     this.getContactList();
            this.http.onEnd();
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'To create new request please save address details first.';
            // alert('To create new request please save address details first.');
            this.http.onEnd();
            // this.router.navigateByUrl('/app/trade/details');
        }
    }
    onChangeEvent(ev) {
        console.log(ev.value); // should print option1
        let streetvalue = ev.value;
        var codeFound = this.addressList.find(x => x.street == streetvalue);
        if (codeFound != undefined && streetvalue == codeFound.street) {
            this.data.shipFromCity = codeFound.city;
            this.data.shipFromCountryCode = codeFound.country;
            this.data.shipFromPostalCode = codeFound.zipCode;
            this.newAddress = codeFound;
            this.enableButtons = true;

        }
    }
    updateRequest() {
        if (this.newAddress == undefined || this.newAddress == null) {
            return;
        }
        this.http.postRequest(this.newAddress, 'returnOrder/v1/updateAddressReturnRequest?sapOrderId=' + this.id)
            .subscribe(
                res => {
                    let data = res;
                    this.http.onEnd();
                    console.log(res);
                    if (data['status'] == 'Success') {
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = 'UPS Label Request data updated successfully for order Id :-' + this.id;
                    } else {
                        this.dialogRef = this.dialog.open(dialogComponent);
                        if (data['errorMessage']) {
                            this.dialogRef.componentInstance.msg = data['errorMessage'];
                        } else {
                            this.dialogRef.componentInstance.msg = 'Failed to process request. Please contact administrator.';
                        }
                    }
                    this.http.onEnd();
                },
                err => {
                    console.log(err)
                    if(err && err.status!=0){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;
                        
                    }
                    this.http.onEnd();
                });

    }
    public saveNewAddress() {
        let tradeId = this.tradeId;
        this.dialogRef1 = this.dialog.open(addNewAddressComponent);
        this.dialogRef1.componentInstance.tradeId = tradeId;
    }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/dashboard/dashboard.component.ts